import { IBreadcrumb } from '@quicktools/shared-components/components/core/Breadcrumb/types';

const lowerCaseWords = ['to', 'a', 'from'];
const upperCaseWords = ['pdf', 'heic', 'png', 'svg', 'ppt', 'mov', 'mkv', 'jpg', 'mp4', 'mp3'];
const firstAndLastUpper = ['webm'];

function getSubLinkText(text: string) {
  const newTexts = text.split('-');
  let newText = '';
  newTexts.forEach((t) => {
    if (lowerCaseWords.find((lcw) => lcw === t)) newText += t + ' ';
    else if (upperCaseWords.find((ucw) => ucw === t)) newText += t.toUpperCase() + ' ';
    else if (firstAndLastUpper.find((f) => f === t))
      newText +=
        t.charAt(0).toUpperCase() +
        t.slice(1, t.length - 1) +
        t.charAt(t.length - 1).toUpperCase() +
        ' ';
    else newText += t.charAt(0).toUpperCase() + t.slice(1) + ' ';
  });
  return newText;
}

function getBreadcrumbSublinks(pathname: string) {
  if (!pathname.includes('/') || pathname === '/') return [];

  let withoutFirstAndLast = pathname.startsWith('/') ? pathname.slice(1) : pathname;
  withoutFirstAndLast = withoutFirstAndLast.endsWith('/')
    ? withoutFirstAndLast.slice(0, -1)
    : withoutFirstAndLast;

  const sublinks = withoutFirstAndLast.split('/');

  const items: IBreadcrumb[] = [];
  items.push({
    text: getSubLinkText(sublinks[0]),
    href: `/${sublinks[0]}`,
  });
  for (let i = 1; i < sublinks.length; i++) {
    let sublink = '';
    for (let j = 0; j <= i; j++) {
      sublink = sublink + '/' + sublinks[j];
    }
    items.push({
      text: getSubLinkText(sublinks[i]),
      href: sublink,
    });
  }

  return items;
}
export default getBreadcrumbSublinks;
